import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';

import { AgeGateContext } from 'apps/age_gate/ageGateContext';

export const TranslatedTextMessage = ({ id, inlineData }) => {
  const { messageKeys } = React.useContext(AgeGateContext);

  return <TranslatedMessage id={messageKeys[id]} values={inlineData} />;
};
